import { Search } from "lucide-react";
import { JumpToPageDialog } from "src/components/misc/jump-to-page-dialog";
import { Pagination, PaginationContent, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious } from "src/components/pagination";

interface CustomerPagination {
  currentPageNumber: number;
  onPrev: () => void;
  onNext: () => void;
  onJumpToPage: (page: number) => void;
  isFetching: boolean;
  hasPrev: boolean;
  hasNext: boolean;
}

export const CustomerListPagination = ({
  currentPageNumber,
  onPrev,
  onNext,
  onJumpToPage,
  isFetching,
  hasPrev,
  hasNext
}: CustomerPagination) => {
  return (
    <Pagination>
      <PaginationContent className="join join-horizontal">
        <PaginationItem>
          <PaginationPrevious onClick={onPrev} aria-disabled={!hasPrev || isFetching} className="cursor-pointer" />
        </PaginationItem>
        <PaginationItem>
          <PaginationLink isActive>{currentPageNumber}</PaginationLink>
        </PaginationItem>
        <PaginationItem className="cursor-pointer">
          <JumpToPageDialog
            currentPageNumber={currentPageNumber}
            onJumpToPage={onJumpToPage}
          >
            <PaginationLink>
              <Search />
            </PaginationLink>
          </JumpToPageDialog>
        </PaginationItem>
        <PaginationItem>
          <PaginationNext onClick={onNext} aria-disabled={!hasNext || isFetching} className="cursor-pointer" />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
};
